// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root___rlw5","title":"Info_title__DKcYm","selects":"Info_selects__3SsYq","requiredAsterisk":"Info_requiredAsterisk__2W_DU"};